import { Loader } from "@googlemaps/js-api-loader";
class storeLocator {
  constructor() {
    this.initMaps();
    this.storeJson = window.storeJson;
    this.storePin = window.storePin;
    this.mapStyle = [
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#444444",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f2f2f2",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#f8f8f8",
          },
          {
            visibility: "on",
          },
        ],
      },
    ];
  }
  initMaps() {
    let $this = this;

    const loader = new Loader({
      apiKey: "AIzaSyBW6nnnrQlEZYq0umDrNbfA6WNrfjuKP2M",
      version: "weekly",
      libraries: ["places"],
    });

    //Removes default google font from google map api
    // $this.removeGoogleFont();

    loader
      .load()
      .then(() => {

        $this.initMap();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initMap() {
    let $this = this;
    // Create the map.
    const map = new google.maps.Map(document.getElementById("store-locator"), {
      zoom: 5,
      center: {
        lat: -40.6725219,
        lng: 172.360113,
      },
      styles: $this.mapStyle,
      mapTypeControl: false
    });

    // Load the stores GeoJSON onto the map.
    // map.data.loadGeoJson('stores.json', {idPropertyName: 'storeid'});

    map.data.addGeoJson($this.storeJson);

    // Define the custom marker icons, using the store's "category".
    map.data.setStyle((feature) => {
      return {
        icon: {
          // url: `img/icon_${feature.getProperty('category')}.png`,
          url: $this.storePin,
          scaledSize: new google.maps.Size(40, 54),
        },
      };
    });

    const apiKey = "AIzaSyBW6nnnrQlEZYq0umDrNbfA6WNrfjuKP2M";
    const infoWindow = new google.maps.InfoWindow();

    const image = {
      url: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
      // This marker is 20 pixels wide by 32 pixels high.
      size: new google.maps.Size(20, 32),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(0, 32),
    };

    // Show the information for a store when its marker is clicked.
    map.data.addListener("click", (event) => {
      const category = event.feature.getProperty("category");
      const name = event.feature.getProperty("name");
      const link = event.feature.getProperty("link");

      const position = event.feature.getGeometry().get();
      // const content = $this.sanitizeHTML`
      const content = `
      <div style="width: 250px;">
        <h6 class="font-bold store-name__name">${name}</h6>
        <p class="store-name__button"><a href="${link}" class="button">View details</a></p>
      </div>
      `;

      infoWindow.setContent(content);
      infoWindow.setPosition(position);
      infoWindow.setOptions({
        pixelOffset: new google.maps.Size(0, -30),
      });
      infoWindow.open(map);
    });

    //Manually Click on store to show
    map.data.forEach(function(feature) {
      // console.log(feature.getProperty('storeid'));
      // if (feature.getProperty('name') === "Auckland &#8211; Horizon Fireplaces NZ" ) { //Match against name and trigger click
      if (feature.getProperty('storeid') === 1828 ) {
        google.maps.event.trigger(map.data, 'click', {
          feature: feature
        });
      }
    });

    // Build and add the search bar
    const card = document.createElement("div");
    const titleBar = document.createElement("div");
    const title = document.createElement("div");
    const container = document.createElement("div");
    const input = document.createElement("input");
    const options = {
      //types: ['address'], //full address
      types: ["(regions)"], //postcode
      componentRestrictions: {
        country: "nz",
      },
    };

    card.setAttribute("id", "search-postcode-block");
    title.setAttribute("id", "title");
    title.textContent = "Find your Nearest Dealer";
    titleBar.appendChild(title);
    container.setAttribute("id", "search-postcode-content");
    input.setAttribute("id", "search-postcode-input");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", "Enter your postcode");
    container.appendChild(input);
    card.appendChild(titleBar);
    card.appendChild(container);
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);

    // Make the search bar into a Places Autocomplete search bar and select
    // which detail fields should be returned about the place that
    // the user selects from the suggestions.
    const autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.setFields(["address_components", "geometry", "name"]);

    // Set the origin point when the user selects an address
    const originMarker = new google.maps.Marker({
      map: map,
    });
    originMarker.setVisible(false);
    let originLocation = map.getCenter();

    autocomplete.addListener("place_changed", async () => {
      originMarker.setVisible(false);
      originLocation = map.getCenter();
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No address available for input: '" + place.name + "'");

        return;
      }

      // Recenter the map to the selected address
      originLocation = place.geometry.location;
      map.setCenter(originLocation);
      map.setZoom(9);
      

      originMarker.setPosition(originLocation);
      originMarker.setVisible(true);

      // Use the selected address as the origin to calculate distances
      // to each of the store locations
      const rankedStores = await $this.calculateDistances(
        map.data,
        originLocation
      );
      // $this.showStoresList(map.data, rankedStores);

      return;
    });
  }

  /**
   * Use Distance Matrix API to calculate distance from origin to each store.
   * @param {google.maps.Data} data The geospatial data object layer for the map
   * @param {google.maps.LatLng} origin Geographical coordinates in latitude
   * and longitude
   * @return {Promise<object[]>} n Promise fulfilled by an array of objects with
   * a distanceText, distanceVal, and storeid property, sorted ascending
   * by distanceVal.
   */
  async calculateDistances(data, origin) {
    let $this = this;
    const stores = [];
    const destinations = [];

    // Build parallel arrays for the store IDs and destinations
    data.forEach((store) => {
      const storeNum = store.getProperty("storeid");
      const storeLoc = store.getGeometry().get();

      stores.push(storeNum);
      destinations.push(storeLoc);
    });

    // Retrieve the distances of each store from the origin
    // The returned list will be in the same order as the destinations list
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix = (service, parameters) =>
      new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
          if (status != google.maps.DistanceMatrixStatus.OK) {
            reject(response);
          } else {
            const distances = [];
            const results = response.rows[0].elements;
            for (let j = 0; j < results.length; j++) {
              const element = results[j];
              const distanceText = element.distance.text;
              const distanceVal = element.distance.value;
              const distanceObject = {
                storeid: stores[j],
                distanceText: distanceText,
                distanceVal: distanceVal,
              };
              distances.push(distanceObject);
            }

            resolve(distances);
          }
        });
      });

    const distancesList = await getDistanceMatrix(service, {
      origins: [origin],
      destinations: destinations,
      travelMode: "DRIVING",
      unitSystem: google.maps.UnitSystem.METRIC,
    });

    distancesList.sort((first, second) => {
      return first.distanceVal - second.distanceVal;
    });

    return distancesList;
  }

  /**
   * Build the content of the side panel from the sorted list of stores
   * and display it.
   * @param {google.maps.Data} data The geospatial data object layer for the map
   * @param {object[]} stores An array of objects with a distanceText,
   * distanceVal, and storeid property.
   */
  showStoresList(data, stores) {
    let $this = this;
    if (stores.length == 0) {
      console.log("empty stores");
      return;
    }

    let panel = document.createElement("div");
    // If the panel already exists, use it. Else, create it and add to the page.
    if (document.getElementById("panel")) {
      panel = document.getElementById("panel");
      // If panel is already open, close it
      if (panel.classList.contains("open")) {
        panel.classList.remove("open");
      }
    } else {
      panel.setAttribute("id", "panel");
      const body = document.body;
      body.insertBefore(panel, body.childNodes[0]);
    }

    // Clear the previous details
    while (panel.lastChild) {
      panel.removeChild(panel.lastChild);
    }

    stores.forEach((store) => {
      // Add store details with text formatting
      const name = document.createElement("p");      
      name.classList.add("place");
      /* const currentStore = data.getFeatureById(store.storeid);  
      name.textContent = currentStore.getProperty("name");
      panel.appendChild(name); */
      const distanceText = document.createElement("p");
      distanceText.classList.add("distanceText");
      distanceText.textContent = store.distanceText;
      panel.appendChild(distanceText);
    });

    // Open the panel
    panel.classList.add("open");

    return;
  }

  sanitizeHTML(strings) {
    const entities = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "-": "&#8211;",
    };
    let result = strings[0];
    for (let i = 1; i < arguments.length; i++) {
      result += String(arguments[i]).replace(/[&<>'"]/g, (char) => {
        return entities[char];
      });
      result += strings[i];
    }
    return result;
  }

  removeGoogleFont() {
    var head = document.getElementsByTagName("head")[0];

    // Save the original method
    var insertBefore = head.insertBefore;

    // Replace it!
    head.insertBefore = function (newElement, referenceElement) {
      if (
        newElement.href &&
        newElement.href.indexOf(
          "https://fonts.googleapis.com/css?family=Roboto"
        ) === 0
      ) {
        // console.info('Prevented Roboto from loading!');
        return;
      }

      insertBefore.call(head, newElement, referenceElement);
    };
  }
}

export default storeLocator;



// WEBPACK FOOTER //
// ./scripts/components/store-locator.js